// Delete-dashboard confirm — the §2.12 archive-grade name-match pattern in
// its §4a Modal container (dashboard.md). The danger button enables only on
// an exact display-name match; the confirmation input resets when the target
// changes. Mutation errors render inline and keep the modal open for retry.

import { useState } from "react";

import {
  Button,
  Inline,
  InlineError,
  Modal,
  Stack,
  Text,
  TextInput,
} from "../ui";

export interface DashboardDeleteModalProps {
  dashboardName: string;
  error: string | null;
  isOpen: boolean;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DashboardDeleteModal(props: DashboardDeleteModalProps) {
  return (
    <DashboardDeleteModalContent
      key={`${props.dashboardName}:${props.isOpen ? "open" : "closed"}`}
      {...props}
    />
  );
}

function DashboardDeleteModalContent({
  dashboardName,
  error,
  isOpen,
  isPending,
  onCancel,
  onConfirm,
}: DashboardDeleteModalProps) {
  const [confirmation, setConfirmation] = useState("");
  const canDelete = confirmation === dashboardName && !isPending;

  return (
    <Modal ariaLabel="Delete dashboard" isOpen={isOpen} onDismiss={onCancel}>
      <Stack gap={4}>
        <Text variant="muted">
          {`Delete ${dashboardName}? This removes it from the picker and cannot be undone here.`}
        </Text>
        <TextInput
          label="Type the dashboard name to confirm"
          value={confirmation}
          onChange={(event) => {
            setConfirmation(event.currentTarget.value);
          }}
        />
        {error ? <InlineError>{error}</InlineError> : null}
        {/* §2.12: the danger action is always last in its row. */}
        <Inline>
          <Button disabled={isPending} variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button disabled={!canDelete} variant="danger" onClick={onConfirm}>
            Confirm delete
          </Button>
        </Inline>
      </Stack>
    </Modal>
  );
}
